import { Box, styled } from '@mui/material';
import classNames from 'classnames';

import { EAircraftStatus, EMaoMaintenanceBadge, ESeverity } from '#shared';

import { useAircraftDrawer } from './AircraftDrawerContext';
import { EventTime } from './EventTime';

const PREFIX = 'TSMED-AircraftDrawerDutyEvents';

export const aircraftDrawerDutyEventsClasses = {
  events: `${PREFIX}-events`,
  event: `${PREFIX}-event`,
  label: `${PREFIX}-label`,
  time: `${PREFIX}-time`,
};

const Root = styled(Box)(({ theme: { spacing, palette } }) => ({
  [`.severity-status-${ESeverity.CRITICAL}`]: {
    color: palette.error[500],
    background: `${palette.error[500]}1A`,
  },
  [`.severity-status-${ESeverity.MAJOR}`]: {
    color: palette.yellow[500],
    background: `${palette.yellow[500]}1A`,
  },
  [`.severity-status-${ESeverity.MINOR}`]: {
    color: palette.mint[500],
    background: `${palette.mint[500]}1A`,
  },
  [`.severity-status-${ESeverity.LOW}`]: {
    color: '#FFFFFF',
    background: `#FFFFFF1A`,
  },
  [`.status-${EAircraftStatus.NotAvailable}`]: {
    color: palette.grey[800],
    background: `${palette.grey[800]}1A`,
  },
  [`.aircraft-status-${EAircraftStatus.Available}`]: {},
  [`.aircraft-status-${EAircraftStatus.Maintenance}`]: {
    color: palette.error[700],
    background: `${palette.error[700]}1A`,
    [`&.maintenance-type-${EMaoMaintenanceBadge.AOG}`]: {
      color: palette.error[200],
      background: `${palette.error[200]}1A`,
    },
  },

  display: 'flex',
  flexDirection: 'column',
  gap: spacing(1),
  [`.${aircraftDrawerDutyEventsClasses.event}`]: {
    display: 'flex',
    gap: spacing(1),
    alignItems: 'baseline',
    [`.${aircraftDrawerDutyEventsClasses.label},.${aircraftDrawerDutyEventsClasses.time}`]:
      {
        [`&.event-type-NoCrew`]: {
          color: `${palette.grey[600]}`,
        },
        background: `${palette.grey[600]}24`,
        padding: spacing(0.5, 1),
        lineHeight: spacing(4.5),
        fontSize: spacing(3),
      },
    [`.${aircraftDrawerDutyEventsClasses.label}`]: {
      width: 140,
      textAlign: 'center',
    },
    [`.${aircraftDrawerDutyEventsClasses.time}`]: {
      sup: {
        lineHeight: 0,
      },
    },
  },
}));

export const AircraftDrawerDutyEvents = () => {
  const {
    aircraftData: { dutyEvents },
  } = useAircraftDrawer();
  return (
    <Root>
      {dutyEvents.slice(0, 4).map(event => (
        <Box
          key={event.id}
          className={classNames(aircraftDrawerDutyEventsClasses.event, {
            [`severity-status-${event.severity}`]: event.severity,
          })}
        >
          <Box
            className={classNames(
              aircraftDrawerDutyEventsClasses.label,
              `event-type-${event.type}`,
              {
                [`sverity-status-${event.severity}`]: event.severity,
              },
            )}
          >
            {event.label}
          </Box>
          <Box
            className={classNames(
              aircraftDrawerDutyEventsClasses.time,
              `event-type-${event.type}`,
              {
                [`sverity-status-${event.severity}`]: event.severity,
              },
            )}
          >
            <EventTime
              startUnix={event.startUnix}
              startIanaTimezone={event.startIanaTimezone}
              endUnix={event.endUnix}
              endIanaTimezone={event.endIanaTimezone}
            />
          </Box>
        </Box>
      ))}
    </Root>
  );
};
